<template>
  <q-card flat>
    <q-card-section>
      <q-table
          :data="items"
          row-key="Sale_Num"
          flat
          wrap-cells
          :rows-per-page-options="[pagination.rowsPerPage]"
          :pagination.sync="pagination">
        <template v-slot:header>
          <tr class="text-center text-subtitle1">
            <td>سفارش</td>
            <td>حواله</td>
            <td>فاکتور</td>
            <td>تاریخ فاکتور</td>
            <td>تعداد</td>
            <td>مبلغ</td>
            <td>طرف معامله</td>
            <td>استان</td>
            <td>شهر</td>
            <td>پورسانت</td>
          </tr>
          <tr class="text-center text-subtitle1">
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td>
              <q-chip color="green-10" text-color="white"
                      :label="lodash.sumBy(items, item=> parseInt(item.SalePay)).toLocaleString()" square/>
            </td>
            <td></td>
            <td></td>
            <td></td>
            <td>
              <q-chip label="زیرفاکتور" text-color="white" color="indigo" square>
                <q-badge color="green-10" text-color="white"
                         class="q-ml-xs"
                         :label="(Math.round(lodash.sumBy(items, item=> item.Profit * 1/3.0))).toLocaleString()"/>
              </q-chip>
              <q-space/>
              <q-chip label="هدف" text-color="white" color="indigo" square>
                <q-badge color="green-10" class="q-ml-xs" text-color="white"
                         :label="(Math.round(lodash.sumBy(items.filter(item=>item.Sale_PayReceive), item=> item.Target * 2/3.0))).toLocaleString()">
                </q-badge>

                 <q-badge color="red" class="q-ml-xs" text-color="white"
                         :label="(Math.round(lodash.sumBy(items.filter(item=>!item.Sale_PayReceive), item=> item.Target * 2/3.0))).toLocaleString()">
                 </q-badge>
              </q-chip>
            </td>
          </tr>
        </template>
        <template v-slot:body="props">
          <q-tr :props="props" class="my-class text-center">
            <td>
              <q-chip :size="$q.screen.lt.md?'md':'md'" square color="indigo" text-color="white"
                      icon="qr_code"> {{ props.row.Order_Num }}
              </q-chip>
            </td>
            <td>
              <q-chip :size="$q.screen.lt.md?'md':'md'" square
                      color="indigo" text-color="white"
                      icon="qr_code"> {{ props.row.Hava_Num }}
              </q-chip>
            </td>
            <td>
              <q-chip :size="$q.screen.lt.md?'md':'md'" clickable square color="indigo"
                      text-color="white"
                      icon="qr_code" :label="props.row.Sale_Num" @click="showDetails(props.row)"/>
            </td>
            <td>
              <q-chip :size="$q.screen.lt.md?'md':'md'" square color="red" icon="event" outline>
                ({{ props.row.Sale_Date }})
              </q-chip>
            </td>
            <td>
              <q-chip :size="$q.screen.lt.md?'md':'md'" square color="purple" icon="functions"
                      text-color="white">
                {{ props.row.Sale_Count }} عدد
              </q-chip>
            </td>
            <td>
              <q-chip :size="$q.screen.lt.md?'md':'md'" square color="green-14" icon="attach_money"
                      text-color="white">
                {{ props.row.Sale_Pay | toCurrency }} ریال
              </q-chip>
            </td>
            <td>
              <q-chip clickable :size="$q.screen.lt.md?'md':'md'" square icon="person"
                      @click="showCustomerInfo(props.row)">
                {{ props.row.Cs_Name }}
              </q-chip>
            </td>
            <td>
              <q-chip :size="$q.screen.lt.md?'md':'md'" square icon="business">
                {{ props.row.City_Name }}
              </q-chip>
            </td>
            <td>
              <q-chip :size="$q.screen.lt.md?'md':'md'" square icon="business">
                {{ props.row.State_Name }}
              </q-chip>
            </td>
            <td>
              <q-chip square color="deep-orange" text-color="white" v-if="props.row.Target!==0">
                <span dir="ltr">{{ (Math.round(props.row.Profit * 1 / 3.0)).toLocaleString() }}</span>
                <q-tooltip>
                  زیر فاکتور
                </q-tooltip>
              </q-chip>
              <q-chip icon="track_changes" square :color="props.row.Sale_PayReceive?'green-10':'red'" text-color="white"
                      v-if="(Math.round(props.row.Target * (2/3.0)))">
                <span dir="ltr">{{ (Math.round(props.row.Target * (2 / 3.0))).toLocaleString() }}</span>
                <q-tooltip v-if="props.row.Sale_PayReceive">
                  هدف فاکتور تسویه شده
                </q-tooltip>
                <q-tooltip v-if="!props.row.Sale_PayReceive">
                  هدف فاکتور تسویه نشده
                </q-tooltip>
              </q-chip>
            </td>
          </q-tr>
        </template>
      </q-table>
    </q-card-section>

    <q-dialog
        maximized
        v-model="showOrderDetailsDialog">
      <FactorDetails :sale-state="selectedSaleStat" :sale-num="selectedSaleNum"
                     :sale-kind="1" :factor-items="factorItems"/>
    </q-dialog>

    <q-dialog :maximized="$q.screen.lt.md" v-model="customerInfoDialog">
      <CustomerInfo :selected-customer="selectedCustomer"/>
    </q-dialog>
  </q-card>
</template>

<script>
import FactorDetails from "@/components/Factor/FactorDetails";
import {mapActions} from "vuex";
import CustomerInfo from "@/components/customers/CustomerInfo";

export default {
  name: "AgentFactorListDesktop",
  components: {CustomerInfo, FactorDetails},
  props: {
    items: {
      type: [],
      required: true
    },
  },
  data() {
    return {
      customerInfoDialog: false,
      pagination: {
        rowsPerPage: 0
      },
      factorItems: [],
      selectedSaleNum: undefined,
      selectedFactor: undefined,
      showOrderDetailsDialog: false,
      selectedSaleStat: 1,
      selectedCustomer: undefined
    }
  },
  methods: {
    ...mapActions({
      getFactorItems: 'Orders/getFactorItems',
      getCustomerInfo: 'Customers/get_customer_info',
    }),
    showDetails(row) {
      this.getFactorItems({
        sale_num: row.Sale_Num,
        sale_kind: 1
      }).then((res) => {
        this.factorItems = res;
        this.selectedSaleNum = row.Sale_Num;
        this.selectedFactor = row
        this.showOrderDetailsDialog = true;
      })
    },
    showCustomerInfo(row) {
      this.getCustomerInfo(row.Cs_ID).then((res) => {
        this.selectedCustomer = res.data[0];
        this.customerInfoDialog = true;
      })
    },
  }
}
</script>

<style scoped>

</style>